import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FreightShipperFormsTriggersService {
  private readonly _freightShipSaveTrigger = signal(false);
  private readonly _addStopTrigger = signal(false);

  // constructor() {}

  // To detect in main component if an action is triggered
  public get isFreightShipperSaveTrigger(): Signal<boolean> {
    return this._freightShipSaveTrigger.asReadonly();
  }

  public resetFreightShipperSaveTrigger(): void {
    this._freightShipSaveTrigger.set(false);
  }

  public launchFreightShipperSaveTrigger(): void {
    this._freightShipSaveTrigger.set(true);
  }

  public get isAddStopTrigger(): Signal<boolean> {
    return this._addStopTrigger.asReadonly();
  }

  public resetAddStopTrigger(): void {
    this._addStopTrigger.set(false);
  }

  public launchAddStopTrigger(): void {
    this._addStopTrigger.set(true);
  }
}
